var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarRateEmpty = function SvgStarRateEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m18.306 4.68 2.347 4.693c.32.653 1.174 1.28 1.894 1.4l4.253.707c2.72.453 3.36 2.426 1.4 4.373l-3.307 3.307c-.56.56-.867 1.64-.693 2.413l.947 4.093c.746 3.24-.974 4.494-3.84 2.8l-3.987-2.36c-.72-.427-1.907-.427-2.64 0l-3.987 2.36c-2.853 1.694-4.586.427-3.84-2.8l.947-4.093c.173-.774-.133-1.854-.693-2.413L3.8 15.853c-1.947-1.947-1.32-3.92 1.4-4.373l4.253-.707c.707-.12 1.56-.747 1.88-1.4L13.68 4.68c1.28-2.547 3.36-2.547 4.627 0Z"
  })));
};
export default SvgStarRateEmpty;